import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import SponsorCardSettings from "@/components/editor/shared/sponsors/sponsor-card/sponsor-card-settings-component";
import type { SponsorCardProps } from "@/components/editor/shared/sponsors/sponsors-settings/sponsors-settings-component";

import {
  StyledSponsorCard,
  StyledSponsorCardLogo,
  StyledSponsorCardText,
} from "./sponsor-card-component-styles";

export default function SponsorCard({ sponsor }: SponsorCardProps) {
  const {
    connectors: { connect },
  } = useNode();
  const { t } = useTranslation();

  const { isEnabled } = useEditor((state) => ({
    isEnabled: state.isEnabled(),
  }));

  return (
    <StyledSponsorCard
      target="_blank"
      rel="sponsored"
      aria-label={`${sponsor.name} ${t("common.website")} (${t(
        "common.opens-in-new-window"
      )})`}
      href={isEnabled ? null : sponsor.website}
      ref={connect}
    >
      <StyledSponsorCardLogo src={sponsor.image_url} alt="" draggable="false" />
      <StyledSponsorCardText>{sponsor.name}</StyledSponsorCardText>
    </StyledSponsorCard>
  );
}

SponsorCard.craft = {
  custom: {
    displayName: "Sponsor Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: SponsorCardSettings,
  },
};
